import React from 'react';
import PropTypes from 'prop-types';

const Spinner = props => {
  const { fullScreen, hiddden, id } = props;

  return (
    <div
      id={id}
      style={{
        height: '100%',
        width: props.width || '100%',
        display: hiddden ? 'none' : 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        transform: props.scale ? `scale(${props.scale})` : '',
        opacity: fullScreen ? 0.5 : 1,
        position: fullScreen ? 'fixed' : '',
        top: fullScreen ? 0 : 'inherit',
        left: fullScreen ? 0 : 'inherit',
        background: props.background || (fullScreen ? '#ddd' : 'inherit'),
        zIndex: 20001
      }}
    >
      <div className="lds-spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

Spinner.propTypes = {
  hiddden: PropTypes.bool,
  fullScreen: PropTypes.bool,
  width: PropTypes.number,
  scale: PropTypes.number,
  background: PropTypes.string,
  id: PropTypes.string
};
export default Spinner;
